import { SharedPage } from '../base.js';

export class AccountVerified extends SharedPage {
  static timl = `
    section.auth-page[aria-labelledby="account-verified-title"]
      .stacked-form.auth-form.auth-status
        .auth-status-mark[aria-hidden="true"]
          span.auth-check-icon
        header.auth-header
          h1#account-verified-title Setting up your account
          p#account-verified-message Your email is verified. We are creating your Instant Suite account now.
        .auth-loader-wrap#account-verified-loader
          div.loader
          span Creating your account and profile…
        .auth-account-actions#account-verified-actions[style="display:none;"]
          a.auth-primary.auth-primary-link#account-verified-primary[href="/"] Go to dashboard
          button.auth-primary#account-verified-retry[type="button"] Retry account setup
  `;

  static setState({ title, message, loading, showPrimary, showRetry, primaryHref }) {
    const titleEl = document.querySelector('#account-verified-title');
    const messageEl = document.querySelector('#account-verified-message');
    const loaderEl = document.querySelector('#account-verified-loader');
    const actionsEl = document.querySelector('#account-verified-actions');
    const primaryEl = document.querySelector('#account-verified-primary');
    const retryEl = document.querySelector('#account-verified-retry');
    const showActions = Boolean(showPrimary || showRetry);

    if (titleEl && title) titleEl.innerText = title;
    if (messageEl && message) messageEl.innerText = message;
    if (loaderEl) loaderEl.style.display = loading ? 'flex' : 'none';
    if (actionsEl) actionsEl.style.display = showActions ? 'flex' : 'none';
    if (primaryEl) primaryEl.style.display = showPrimary ? 'flex' : 'none';
    if (retryEl) retryEl.style.display = showRetry ? 'flex' : 'none';
    if (primaryEl && primaryHref) primaryEl.setAttribute('href', primaryHref);
  }

  static async runBootstrap() {
    AccountVerified.setState({
      title: 'Setting Up Your Account',
      message: 'Your email is verified. We are creating your Instant Suite account now.',
      loading: true,
      showPrimary: false,
      showRetry: false,
      primaryHref: '/'
    });

    try {
      await Auth.ensureSuiteBootstrap();
      AccountVerified.setState({
        title: 'Your Account Is Ready',
        message: 'Thanks for verifying your email address. Your account was created automatically and you can continue into the dashboard now.',
        loading: false,
        showPrimary: true,
        showRetry: false,
        primaryHref: '/'
      });
    } catch (error) {
      AccountVerified.setState({
        title: 'We Could Not Finish Setting Up Your Account',
        message: error?.message || 'Your email is verified, but we could not create your Instant Suite account. Please try again.',
        loading: false,
        showPrimary: false,
        showRetry: true,
        primaryHref: '/'
      });
    }
  }

  static javascript() {
    const retryButton = document.querySelector('#account-verified-retry');
    if (retryButton) {
      retryButton.onclick = () => AccountVerified.runBootstrap();
    }
    return AccountVerified.runBootstrap();
  }
}
